import { SET_USER_DATA } from "../constants/types";
import authUtils from "../utils/authUtils";
import jwtDecode from "jwt-decode";

const initState = {
  user: null,
};

if (authUtils.getUserToken()) {
  const userData = jwtDecode(authUtils.getUserToken());
  initState.user = userData.Email;
}

const userReducer = (state = initState, action) => {
  console.log("jkadashdghaskgdjsd",action)

  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        user: action.payload,
      };
    case "LOGOUT":
      initState.user = null;
      state = initState;
    // eslint-disable-next-line no-fallthrough
    default:
      return { ...state };
  }
};

export default userReducer;